import styled from "styled-components";
export const ProfileMenu = styled.div`
   display: flex;
   flex-direction: column;
   user-select: none;
   .menuitem {
      align-items: center;
      cursor: pointer;
      height: 50px;
   }
   #profile {
      img {
         margin-left: 4px;
         content: url("https://s3.amazonaws.com/static.alohabots.xyz/site/iconfont/profile_icon.svg");
      }
      p {
         color: "#000";
         margin-left: 16px;
         font-size: 16px;
      }
      &:hover {
         img {
            content: url("https://s3.amazonaws.com/static.alohabots.xyz/site/iconfont/profile_icon_green.svg");
         }
         p {
            color: #24d698;
         }
      }
   }
   #order {
      img {
         margin-left: 4px;
         content: url("https://s3.amazonaws.com/static.alohabots.xyz/site/iconfont/order_record_icon.svg");
      }
      p {
         color: "#000";
         margin-left: 16px;
         font-size: 16px;
      }
      &:hover {
         img {
            content: url("https://s3.amazonaws.com/static.alohabots.xyz/site/iconfont/order_record_icon_green.svg");
         }
         p {
            color: #24d698;
         }
      }
   }
   #logout {
      img {
         margin-left: 4px;
         content: url("https://s3.amazonaws.com/static.alohabots.xyz/site/iconfont/logout_icon.svg");
      }
      p {
         color: "#000";
         margin-left: 16px;
         font-size: 16px;
      }
      &:hover {
         img {
            content: url("https://s3.amazonaws.com/static.alohabots.xyz/site/iconfont/logout_icon_green.svg");
         }
         p {
            color: #24d698;
         }
      }
   }
`;
export const DivBox = styled.div`
   background-color: transparent;
   display: flex;
   user-select: none;
   justify-content: space-between;
   flex-direction: row;
   align-items: center;
   .navlink {
      height: 85px;
      color: #000;
      font-size: 18px;
      line-height: 85px;
      &.active {
         border-bottom: 3px solid #24D698;
      }
   }
`;
